var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.538,
    height: 11.538,
    viewBox: "0 0 11.538 11.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.861,10.161H2.477A1.881,1.881,0,0,1,.66,8.622L.02,4.8a1.992,1.992,0,0,1,.663-1.74L4.015.387a1.9,1.9,0,0,1,2.308,0L9.654,3.055a2.018,2.018,0,0,1,.663,1.74L9.679,8.622A1.907,1.907,0,0,1,7.861,10.161ZM5.164.728a1.132,1.132,0,0,0-.7.226L1.135,3.622a1.272,1.272,0,0,0-.4,1.058l.639,3.827a1.178,1.178,0,0,0,1.106.933H7.861A1.178,1.178,0,0,0,8.967,8.5l.639-3.827a1.281,1.281,0,0,0-.4-1.058L5.871.954A1.16,1.16,0,0,0,5.164.728Z",
    transform: "translate(0.6 0.685)",
    fill: "#3b3939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.562,3.125A1.562,1.562,0,1,1,3.125,1.562,1.565,1.565,0,0,1,1.562,3.125Zm0-2.4a.841.841,0,1,0,.841.841A.845.845,0,0,0,1.562.721Z",
    transform: "translate(4.207 4.687)",
    fill: "#3b3939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.538V11.538H0Z",
    transform: "translate(11.538 11.538) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMobile);
export default __webpack_public_path__ + "static/media/homeMobile.641f1689a33f058d64624773fd0a7257.svg";
export { ForwardRef as ReactComponent };